import { render, staticRenderFns } from "./ApiClaims.vue?vue&type=template&id=ef39a56e&"
import script from "./ApiClaims.vue?vue&type=script&lang=js&"
export * from "./ApiClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports